export default __webpack_public_path__ + "static/media/Globe.ab8bd2e0.svg";